"use client";
import { jsxs as r, jsx as l } from "react/jsx-runtime";
const f = ({
  title: i,
  titleId: a,
  desc: e,
  descId: d,
  ...h
}) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-fm",
    viewBox: "0 0 640 480",
    "aria-labelledby": a,
    "aria-describedby": d,
    ...h,
    children: [
      e ? /* @__PURE__ */ l("desc", { id: d, children: e }) : null,
      i ? /* @__PURE__ */ l("title", { id: a, children: i }) : null,
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "fm-a", children: /* @__PURE__ */ l("path", { fillOpacity: 0.7, d: "M-81.3 0h682.6v512H-81.3z" }) }) }),
      /* @__PURE__ */ r(
        "g",
        {
          fillRule: "evenodd",
          strokeWidth: "1pt",
          clipPath: "url(#fm-a)",
          transform: "translate(76.3)scale(.94)",
          children: [
            /* @__PURE__ */ l("path", { fill: "#6797d6", d: "M-252 0H772v512H-252z" }),
            /* @__PURE__ */ l(
              "path",
              {
                fill: "#fff",
                d: "m259.8 123-32.4 22.2 12.4-35.9-32.5-22.2h40.1l12.4-35.9 12.4 36h40l-32.4 22.1 12.4 35.9M259.8 390l-32.4-22.2 12.4 36-32.5 22.1h40.1l12.4 35.9 12.4-36 40 .1-32.4-22.2 12.4-35.9m-188.4-92.4L79.3 306l1.4-38-37.5-11.7 38.4-11.7 1.3-38 22.3 30.8 38.4-11.8-24.6 30.7 22.4 30.7m274.2-11.7 24.6 30.7-1.4-38 37.5-11.7-38.4-11.7-1.3-38-22.3 30.8-38.4-11.8 24.6 30.7-22.4 30.7"
              }
            )
          ]
        }
      )
    ]
  }
);
export {
  f as default
};
